import { logger as LOG } from '@garnish/logger';

export const appsFlyerLogger = LOG.extend('APPSFLYER');

LOG.enable('APPSFLYER');
